import React from 'react';
import { NavLink } from 'react-router-dom';
import { Heart, MessageCircle, User } from 'lucide-react';
import { useSwipe } from '../context/SwipeContext';

const BottomNav = () => {
  const { matches } = useSwipe();
  
  // Count new matches (matches with no messages exchanged yet)
  const newMatchesCount = matches.filter(match => !match.last_message).length;
  
  const navItems = [
    { path: '/swipe', icon: Heart, label: 'Swype' },
    { path: '/matches', icon: MessageCircle, label: 'Matches', badge: newMatchesCount },
    { path: '/profile', icon: User, label: 'Me' }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-40">
      <div className="max-w-md mx-auto px-4 py-3">
        <div className="flex justify-around">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 px-4 py-2 rounded-lg transition-colors relative ${
                  isActive
                    ? 'text-purple-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <div className="relative">
                    <item.icon
                      className="w-6 h-6"
                      fill={isActive ? 'currentColor' : 'none'}
                    />
                    {/* New matches badge */}
                    {item.badge > 0 && (
                      <div className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 bg-gradient-to-br from-pink-500 to-purple-600 rounded-full flex items-center justify-center">
                        <span className="text-[10px] text-white font-bold">
                          {item.badge > 9 ? '9+' : item.badge}
                        </span>
                      </div>
                    )}
                  </div>
                  <span className="text-xs font-medium">{item.label}</span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BottomNav;
